import { render, staticRenderFns } from "./ModbusRegisterField.vue?vue&type=template&id=931e11ce"
import script from "./ModbusRegisterField.vue?vue&type=script&lang=js"
export * from "./ModbusRegisterField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports